/* eslint-disable max-lines-per-function */
import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "graphql-tag";
import { Form, Formik } from "formik";
import { Grid } from "@mui/material";
import { useSnackbar } from "components/haven-design/snackbar";
import { SubmitButton } from "components/buttons";
import { Button, Modal } from "components/haven-design";
import logger from "services/logger";
import { DialogContent } from "components/haven-design/modal/dialog";
import { removeSelfSubmission, removeSelfSubmissionVariables } from "types/gql-types";

const REMOVE_SELF_SUBMISSION = gql`
  mutation removeSelfSubmission($submissionId: ID!) {
    removeSelfSubmission(submissionId: $submissionId)
  }
`;

const initialData = { reason: "" };

type Props = {
  isOpen: boolean;
  onRequestClose: (isRemoved: boolean) => void;
  submissionId: string;
  interestListName: string;
  formType: string;
}

const RemoveDraftModal: React.FC<Props> =
  ({ submissionId, ...props }) => {
    const { openSnackbar } = useSnackbar();

    const [removeSelfFromList, { loading }] =
      useMutation<removeSelfSubmission, removeSelfSubmissionVariables>(REMOVE_SELF_SUBMISSION);
    const submitForm = () => {
      removeSelfFromList(
        { variables: { submissionId } },
      )
        .then(() => {
          openSnackbar({ message: "Draft removed", status: "success" });
          props.onRequestClose(true);
        })
        .catch((err) => {
          logger.sendError(err);
          openSnackbar({ message: "Draft removal failed", status: "error" });
        });
    };

    return (
      <Modal
        title={
          <h3>
            Remove Draft {props.formType} for&nbsp;
            <strong>{props.interestListName}</strong>?
          </h3>
        }
        fullWidth
        isOpen={props.isOpen}
        onRequestClose={() => props.onRequestClose(false)}>
        <DialogContent>
          <Formik
            initialValues={initialData}
            onSubmit={submitForm}
          >
            {() => (
              <Form>
                <Grid container>
                  <Grid size={{ xs: 12 }}>
                    <p>
                      Are you sure? Removing this Draft {props.formType} cannot be undone.
                    </p>
                  </Grid>

                  <Grid container size={{ xs: 12 }} justifyContent="flex-end">
                    <Grid size={{ xs: 12 }}>
                      <Button color="secondary"
                        style={{ marginRight: "8px" }}
                        onClick={() => props.onRequestClose(false)}>
                            Cancel
                      </Button>
                      <SubmitButton
                        text="Remove"
                        loadingText="Sending"
                        isLoading={loading}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </ Formik>
        </DialogContent>
      </Modal>
    );
  };
export default RemoveDraftModal;
